import React from 'react';
import {NavLink} from "react-router-dom";
import {scrollTo} from "../../../service/ToolsService";

export const Tab = () => {
  return (
    <>
      <ul className="nav nav-tabs mb-3">
        <li className="nav-item">
          <NavLink to={`/admin/office/office`} onClick={scrollTo} className="nav-link">
            <i className="fa-solid fa-users-line me-1"/> Bureau
          </NavLink>
        </li>
        <li className="nav-item">
          <NavLink to={`/admin/office/member`} onClick={scrollTo} className="nav-link">
            <i className="fa-solid fa-user-gear me-1"/> Membres
          </NavLink>
        </li>
      </ul>
    </>
  );
}
